import GLightbox from 'glightbox';
import Swiper from 'swiper/swiper-bundle';

new Swiper('.js-project-swiper', {
	slidesPerView: 'auto',
	spaceBetween: 10,
	loop: true,

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	breakpoints: {
		992: {
			slidesPerView: 'auto',
			spaceBetween: 20,
		},
	},
});

GLightbox({
	selector: '.glightbox2',
	closeOnOutsideClick: false,
	touchNavigation: true,
});
